import { useEffect, useState } from 'react';
import { classTeacherService } from '../services/classTeacher.service';
import { TeacherCandidate } from '../types/classroom.types';

export const useTeacherCandidates = (enabled = true) => {
  const [teacherCandidates, setTeacherCandidates] = useState<TeacherCandidate[]>([]);
  const [isLoadingTeachers, setIsLoadingTeachers] = useState(true);
  const [teachersError, setTeachersError] = useState<string | null>(null);

  useEffect(() => {
    let mounted = true;

    if (!enabled) {
      setIsLoadingTeachers(false);
      return () => {
        mounted = false;
      };
    }

    setIsLoadingTeachers(true);
    classTeacherService
      .listCandidates()
      .then((items) => {
        if (!mounted) return;
        setTeacherCandidates(items);
        setTeachersError(null);
      })
      .catch((error) => {
        if (!mounted) return;
        setTeachersError(error instanceof Error ? error.message : 'Nao foi possivel carregar os professores.');
      })
      .finally(() => {
        if (!mounted) return;
        setIsLoadingTeachers(false);
      });

    return () => {
      mounted = false;
    };
  }, [enabled]);

  return { teacherCandidates, isLoadingTeachers, teachersError };
};
